import { useEffect, useState, useContext } from "react";
import SignIn from "./SignIn/index";
import VerifyCode from "containers/verifyCode/index";
import CreatePin from "containers/AddPin/index";
import SignInWithPin from "containers/SignInWithPin"; // Assuming this exists
import { signInContext } from "context/SigninContext";

const SignInContainer = () => {
  const [step, setStep] = useState(1);
  const [startWithPin, setStartWithPin] = useState(false);
  const { setIsTypeSelect } = useContext(signInContext);

  useEffect(() => {
    const token = localStorage.getItem("izauthtoken");
    setStartWithPin(!!token);
    // Ensure isTypeSelect is set to "individual" when sign-in page loads
    setIsTypeSelect("individual");
  }, [setIsTypeSelect]);

  const nextStep = () => setStep((prev) => prev + 1);

  if (startWithPin) {
    return <SignInWithPin setStartWithPin={setStartWithPin} />;
  }

  return (
    <>
      {step === 1 && <SignIn nextStep={nextStep} />}
      {step === 2 && <VerifyCode signin={true} nextStep={nextStep} />}
      {step === 3 && <CreatePin />}
    </>
  );
};

export default SignInContainer;
